module.exports = __webpack_public_path__ + "static/media/icon-bounce.0a256512.svg";